export default __webpack_public_path__ + "6969dbb306e22a12a16df0e8dd81727e.png";